import { render, staticRenderFns } from "./AddUser.vue?vue&type=template&id=81e5f01c&scoped=true&"
import script from "./AddUser.vue?vue&type=script&lang=ts&"
export * from "./AddUser.vue?vue&type=script&lang=ts&"
import style0 from "./AddUser.vue?vue&type=style&index=0&id=81e5f01c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81e5f01c",
  null
  
)

export default component.exports